import axios from 'api-clients/axios'
import { BASE_API_URL } from 'app-constants'

export const addFavorite = (movie_id) =>
  axios.post(`${BASE_API_URL}/movies/${movie_id}`, {
    movie_id,
    control_action: 'add_favorite'
  })
